import { AccessRequest } from '@/interfaces/accessRequest.interface';
import { ApiResponse } from '@/interfaces/apiresponse.interface';
import { EngagementDTO } from '@/interfaces/engagementDTO.interface';
import { AppNav } from '@/routes/app-nav';
import { EngagementAccessService } from '@/services/engagement-access.service';
import { EngagementService } from '@/services/engagement.service';
import { TitleService } from '@/services/title.service';
import Helpers from '@/shared/helpers';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-access-requests-page',
  standalone: false,
  templateUrl: './access-requests-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./access-requests-page.component.scss']
})

export class AccessRequestsPageComponent implements OnInit, OnDestroy {
  private destroyed = new Subject<any>();
  private helpers: Helpers;

  messageKey: string = "accessRequestPage";
  accessRequestEntries: AccessRequest[] = [];
  loading: boolean = false;
  requestAccessDialogShowing: boolean = false;
  
  @ViewChild(Table) engagementEntryTable!: Table;

  constructor(
    private titleService: TitleService,
    private translocoService: TranslocoService,
    private messageService: MessageService,
    private engagementAccessService: EngagementAccessService,
  ) {
    this.helpers = Helpers.getInstance(this.translocoService);
  }

  ngOnInit(): void {
    this.titleService.setTitle(AppNav.StatusMonitor.title);
    this.loadRequestEntries();
  };

  loadRequestEntries(): void {
    this.loading = true;
    this.engagementAccessService.getAllRequests()
      .then(
        (response: HttpResponse<ApiResponse>) => {
          this.loading = false;
          const entries = (response.body || []) as AccessRequest[];
          this.accessRequestEntries = entries;
        },
        (response: HttpErrorResponse) => {
          this.loading = false;
          this.helpers.showApiResponseMessage(response, this.messageService, this.messageKey);
        }
      );
  }

  approve(requestId: string, accept: boolean){
    this.engagementAccessService.approveRequest(requestId, accept)
      .then(
        (response: HttpResponse<ApiResponse>) => {
          this.loading = false;
          this.loadRequestEntries();
          this.helpers.showApiResponseMessage(response, this.messageService, this.messageKey);
        },
        (response: HttpErrorResponse) => {
          this.loading = false;
          this.helpers.showApiResponseMessage(response, this.messageService, this.messageKey);
        }
      );
  }

  ngOnDestroy(): void {
    this.destroyed.next(undefined);
    this.destroyed.complete();
  }
}